import { NavLink } from "@/types";

const headerNavLinks: NavLink[] = [
  { href: "/publications", title: "Publications" },
  { href: "/patents-awards", title: "Patents & Awards" },
  { href: "/teaching", title: "Teaching" },
  { href: "/blog", title: "Blog" },
  { href: "/projects", title: "Projects" },
  { href: "/about", title: "About" },
];

export default headerNavLinks;
